import {useEffect} from 'react';

import {useOverallInfo, useSettings} from '@components/_context';

import * as Sentry from '@sentry/browser';
import {ConfigurationApplication} from '@application/Config';

const ErrorReporter = () => {
  const {username = ''} = useOverallInfo();
  const {site = ''} = useSettings();

  useEffect(() => {
    Sentry.setTag('userName', username);
  }, [username]);
  useEffect(() => {
    Sentry.setTag('site', site);
  }, [site]);
  useEffect(() => {
    Sentry.setTag('tradename', ConfigurationApplication.retrieve().tradename);
  }, []);

  return null;
};

export {ErrorReporter};
